// WHO HOLDS A SUPPORT TICKET, at a glance (owner, 5 Oct 2026): in All Open a
// ticket nobody has taken must stand out from the ones already in hand — an
// orange "Unassigned" chip, a teal "You", a neutral chip with the agent's name.
import { UserCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function AssigneeChip({ unassigned, mine, name, testId }) {
    const { t } = useTranslation();
    const kind = unassigned ? 'unassigned' : (mine ? 'me' : 'other');
    const tone = {
        unassigned: 'bg-[#D7A05C]/15 text-[#8a5a1a] border-[#D7A05C]/40',
        me: 'bg-[#4ABDBD]/10 text-[#2D8A8A] border-[#4ABDBD]/40',
        other: 'bg-gray-100 text-gray-600 border-gray-200',
    }[kind];
    const label = kind === 'unassigned'
        ? t('support.unassigned', 'Unassigned')
        : (kind === 'me' ? t('support.sender_you', 'You') : (name || t('support.raiser_kind.staff', 'Staff')));
    return (
        <span
            data-testid={testId}
            data-assignee={kind}
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-semibold ${tone}`}
        >
            <UserCheck size={11} />
            {label}
        </span>
    );
}
